import { DeviceAttributes } from '../controllers/devices/commons/register-device';

export class DeviceUtils {
  /**
   * @param item with device attributes
  */
  public static isNumberType = (item: DeviceAttributes): boolean => {
    return typeof(item.seqItem) === 'number';
  }
}
